var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarkIconOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16px",
  height: "18px",
  viewBox: "0 0 16 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.000000 0 0 0 0 0.070588 0 0 0 0 0.274510 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_savearticle",
  transform: "translate(-306.000000, -22.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(306.000000, 22.000000)",
  fill: "#4585FF",
  id: "Fill-14"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.8618719,3.16414286 C14.8618719,2.62542857 14.6777537,2.15678571 14.3101478,1.75757143 C13.9425419,1.35964286 13.5055764,1.16035714 12.9998818,1.16035714 L3.00011823,1.16035714 C2.49442365,1.16035714 2.05682759,1.35964286 1.68922167,1.75757143 C1.32161576,2.15678571 1.13749754,2.62542857 1.13749754,3.16414286 L1.13749754,16.1016429 L8.06904433,11.5662857 L14.8618719,16.0662857 L14.8618719,3.16414286 Z M15.1374187,0.914142857 C15.7124729,1.52357143 16,2.26221429 16,3.12878571 L16,18 L8.06904433,12.7967143 L0,18 L0,3.12878571 C0,2.26221429 0.287527094,1.52357143 0.861950739,0.914142857 C1.43637438,0.305357143 2.12618719,0 2.93075862,0 L13.0686108,0 C13.8738128,0 14.5629951,0.305357143 15.1374187,0.914142857 L15.1374187,0.914142857 Z"
}))))));
export default SvgBookmarkIconOff;